module.exports = __webpack_public_path__ + "static/img/buddy_mini_profile_1080x1068.0496c0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_profile_1080x1068.jpg
// module id = b3pN
// module chunks = 0